import { useTheme } from "@/context/ThemeContext";

const FOLD_PATH =
  "M56 61 H144 a13 13 0 0 1 0 26 H56 a13 13 0 0 0 0 26 H144 a13 13 0 0 1 0 26 H56";

export const BrandMark = ({
  className = "h-7 w-auto",
  color = "#101010",
  animate = false,
  testId = "brand-mark",
}) => (
  <svg
    viewBox="32 50 136 100"
    className={className}
    role="img"
    aria-label="Mutha Paras & Co. mark"
    data-testid={testId}
  >
    <path
      d={FOLD_PATH}
      fill="none"
      stroke={color}
      strokeWidth="13"
      strokeLinecap="round"
      className={animate ? "fold-draw" : undefined}
    />
  </svg>
);

export const BrandLockup = ({ reverse = false, className = "", animate = false }) => {
  const { theme } = useTheme();
  const light = reverse || theme === "dark";

  return (
    <span className={`flex items-center gap-3 ${className}`} data-testid="brand-lockup">
      <BrandMark
        className="h-6 lg:h-7 w-auto shrink-0"
        color={light ? "#F3EFE6" : "#101010"}
        animate={animate}
      />
      <span
        className="hidden sm:block w-px self-stretch my-1"
        style={{ backgroundColor: light ? "rgba(243,239,230,0.35)" : "rgba(16,16,16,0.25)" }}
      />
      <img
        src={light ? "/brand/wordmark-light.svg" : "/brand/wordmark.svg"}
        alt="Mutha Paras & Co. — Lining Fabric Since 1974"
        className="h-5 lg:h-6 w-auto"
        loading="eager"
        data-testid="brand-wordmark"
      />
    </span>
  );
};
